// export const BASE_API = 'http://localhost:8000';

// export const BASE_API = 'http://128.199.231.41:8000';

export const BASE_API = 'https://api.mobileconnectsolution.com';

// export const BASE_API = process.env.REACT_APP_API_ENDPOINT;

export const BASE_PATH_API = '';
